// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"2d06572a","443":"2d06572a","654":"db63436b"}[chunkId] + ".chunk.css";
};